// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:09.922Z
// Property: Caroline Village (ID: 6767906449167008)
// Collections: 18 amenities, 4 floorplans (live), 16 photos, 48 POIs, 2 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167008",
  "property_external_id": "8cq8l42",
  "property_zillow_url": "https://www.zillow.com/apartments/jacksonville-fl/caroline-village/5XnmSM/",
  "property_apartments_url": "https://www.apartments.com/caroline-village-jacksonville-fl/8cq8l42/",
  "property_google_business_url": "https://www.google.com/maps/place/Caroline+Village/data=!4m2!3m1!1s0x0:0xa3cb58d9923c3603?sa=X&ved=2ahUKEwjz8PDmqbySAxVig_0HHaucMUUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "49194523396",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "345CVL",
  "property_status": null,
  "property_slug": "caroline-village",
  "property_name": "Caroline Village",
  "property_website_url": "https://www.carolinevillage.com/",
  "property_domain": "https://www.carolinevillage.com/",
  "property_address": "2929 Justina Rd",
  "property_full_address": "2929 Justina Rd, Jacksonville, FL 32277",
  "property_address_1": "2929 Justina Rd",
  "property_address_2": null,
  "property_address_city": "Jacksonville",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "32277",
  "property_address_country": "US",
  "property_address_county": "Duval County",
  "property_neighborhood_address": "Arlington Manor",
  "property_address_latitude": "30.3542116",
  "property_address_longitude": "-81.59903109999999",
  "property_email": "carolinevillage@liveamc.com",
  "property_phone": "(877) 829-7696",
  "property_call_tracking_phone": "(904) 374-2294",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Experience the vibrant community at Caroline Village in Jacksonville, FL, where modern comfort meets convenience. Choose from spacious studio, one, or two-bedroom apartments featuring fully equipped kitchens and open layouts. Enjoy security, amenities like a picnic area, and engaging resident events—all just steps from shopping and parks! Schedule your tour today!",
  "property_long_description": "Welcome to Caroline Village, your ideal apartment community located in the heart of Jacksonville, FL. Our beautifully designed apartment homes offer a variety of floor plans, including cozy studios, spacious one-bedroom, and comfortable two-bedroom apartments, all crafted to suit your lifestyle. Each unit features fully equipped kitchens, large bedrooms, and modern amenities to ensure your comfort and convenience.\n\nAt Caroline Village, we prioritize your security and peace of mind. Our community boasts controlled access, video patrol, and a dedicated security team, providing a safe environment for you and your loved ones. Enjoy the ease of on-site management and maintenance, along with 24-hour emergency services, ensuring that assistance is always just a call away.\n\nTake advantage of our fantastic community amenities, including laundry facilities, a picnic area equipped with grills, and planned social activities for residents to enjoy. Experience the camaraderie of our welcoming neighborhood, complete with pet-friendly options, so your furry friends can feel at home too!\n\nPositioned conveniently close to shopping, dining, and bus routes, Caroline Village caters to your every need while providing a peaceful retreat. We proudly accept affordable housing programs, including Section 8, making our community accessible for all.\n\nDiscover the perfect balance of comfort, convenience, and community at Caroline Village. Don’t miss out on your chance to be part of this vibrant lifestyle—browse our availability or schedule a tour today to find your new home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d6-0e43-7727-84b9-4f6cda500998.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior courtyard with palm trees and apartment buildings.",
    "public_id": "019d02d6-0e43-7727-84b9-4f6cda500998",
    "storage_key": "property/6767906449167008/019d02d6-0e43-7727-84b9-4f6cda500998.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "93",
  "property_year_built": "1963",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.6989247311828",
  "property_admin_fee": "150",
  "property_application_fee": "35",
  "property_fees_deposit_info": "Deposit: $500-2 mo rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Dogs allowed: up to 2 dogs, each up to 75 lb; Cats allowed: up to 2 cats, each up to 40 lb.",
  "property_pet_policy_description": "Dogs allowed: up to 2 dogs, each up to 75 lb; one-time pet fee: $200 per pet; monthly pet rent: $25 per pet. Cats allowed: up to 2 cats, each up to 40 lb; one-time pet fee: $200 per pet; monthly pet rent: $25 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://carolinevillage.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amccarolinevillage",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019f48b1-542e-768d-9313-47c7d8911897.webp",
  "property_primary_logo_media": {
    "alt_text": "Caroline Village logo",
    "public_id": "019f48b1-542e-768d-9313-47c7d8911897",
    "storage_key": "property/6767906449167008/019f48b1-542e-768d-9313-47c7d8911897.webp",
    "width": 215,
    "height": 32
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019f48b2-22c7-75b9-9728-36743cb78c2e.webp",
  "property_icon_media": {
    "alt_text": "Company logo",
    "public_id": "019f48b2-22c7-75b9-9728-36743cb78c2e",
    "storage_key": "property/6767906449167008/019f48b2-22c7-75b9-9728-36743cb78c2e.webp",
    "width": 28,
    "height": 28
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019f48b1-9c60-757e-ad6e-2e4f95b2156a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Exterior view of a multifamily property building with a clear blue sky.",
    "public_id": "019f48b1-9c60-757e-ad6e-2e4f95b2156a",
    "storage_key": "property/6767906449167008/019f48b1-9c60-757e-ad6e-2e4f95b2156a.webp",
    "width": 215,
    "height": 32
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019f48b1-9166-73c9-81cc-7493102b02b0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black square image",
    "public_id": "019f48b1-9166-73c9-81cc-7493102b02b0",
    "storage_key": "property/6767906449167008/019f48b1-9166-73c9-81cc-7493102b02b0.webp",
    "width": 215,
    "height": 32
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#014D41",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "0 - 2",
  "property_bedrooms_min": "0",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "0 - 2",
  "property_bathrooms_min": "0",
  "property_bathrooms_max": "2",
  "property_sqft_range": "740 - 980",
  "property_sqft_min": "740",
  "property_sqft_max": "980",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1005",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/carolinevillageapts/",
  "property_instagram_url": "https://www.instagram.com/carolineoaksapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZ_Cduv6z5YgRAzY8ktlYy6M",
  "property_youtube_url": "https://www.youtube.com/watch?v=eQXQWjrgK2I#:~:text=If%20you're%20making%20a,to%20live%20in%20Jacksonville%2C%20Florida.",
  "property_yelp_url": "https://www.yelp.com/biz/caroline-village-jacksonville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Caroline Village",
  "property_home_romance_title": "Experience the Joy of Living in Your Perfect Haven",
  "property_home_amenities_blurb": "Welcome to Caroline Village in vibrant Jacksonville, FL, where modern living meets comfort. Choose from stylish studio, one, and two-bedroom floor plans, complete with fully equipped kitchens and spacious layouts. Enjoy our controlled access, community events, and pet-friendly atmosphere, all just minutes from shopping and dining. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Caroline Village in vibrant Jacksonville, FL, our thoughtfully designed one-bedroom, two-bedroom, and studio apartments cater to diverse lifestyles. Each spacious layout features modern amenities and inviting interiors. Dive into our selection and find the ideal floor plan that suits your needs, turning your dream home into reality.",
  "property_home_gallery_blurb": "Welcome to Caroline Village in Jacksonville, FL, where open and efficient apartments meet exceptional community living. Enjoy modern amenities like a fully equipped kitchen, picnic areas, and 24/7 emergency maintenance. Connect with neighbors during our planned events, and embrace the convenience of nearby shopping and parks. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Caroline Village in Jacksonville, FL, where vibrant living meets endless possibilities. Surrounded by cultural gems like the MOSH and Cummer Museum of Art, plus serene parks like Blue Cypress and Reddie Point Preserve, our community offers access to educational institutions and nature’s beauty—your ideal urban retreat awaits!",
  "property_home_reviews_blurb": "At Caroline Village in Jacksonville, FL, our residents rave about their experiences! One delighted resident praised, \"The customer service is amazing, and if you have any problems, she is quick to fix it.\" Enjoy a tranquil atmosphere with top-notch security, where your comfort is our priority. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in vibrant Jacksonville, Caroline Village offers easy access to a rich tapestry of culture and education. With nearby parks, the Jacksonville Zoo, and historic museums like the Cummer Museum of Art, every day presents a new adventure. Dive into life at Caroline Village, where community thrives beyond your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Caroline Village in Jacksonville, where modern living meets convenience! Choose from spacious one and two-bedroom apartments or cozy studios, each designed for comfort. Enjoy amenities like controlled access, on-site management, and vibrant resident events. Embrace a lifestyle that blends relaxation, community, and effortless living.",
  "property_applynow_blurb": "At Caroline Village in Jacksonville, FL, choose from stylish studio, one, or two-bedroom apartments designed for comfort and convenience. Enjoy modern amenities like 24-hour emergency maintenance, a picnic area, and vibrant community events. Embrace a pet-friendly lifestyle in a location close to shopping and parks—your new home awaits!",
  "property_contactus_blurb": "At Caroline Village in Jacksonville, FL, our diverse floor plans cater to every lifestyle. From stylish studios to spacious one and two-bedroom apartments, each home is designed for comfort and convenience. Have questions? Reach out to our leasing team today to find your perfect fit in our vibrant community!",
  "property_faqs_blurb": "At Caroline Village in sunny Jacksonville, FL, our diverse floor plans, including cozy studios, spacious one and two-bedroom apartments, cater to every lifestyle. Need more details? Visit our FAQs page to uncover answers to your burning questions and get to know our vibrant community better!",
  "property_floorplans_blurb": "At Caroline Village in Jacksonville, FL, our thoughtfully designed living spaces cater to your lifestyle. Whether you’re seeking a cozy studio, a spacious one-bedroom, or a two-bedroom haven, we have the ideal floor plan for you. Browse our offerings and step into your dream apartment today.",
  "property_gallery_blurb": "At Caroline Village in Jacksonville, FL, your dream home awaits! Choose from spacious studios, one, and two-bedroom apartments featuring modern comforts like fully equipped kitchens, air conditioning, and ceiling fans. Enjoy a vibrant community with picnic areas and planned social events—all just steps from shopping, dining, and public parks. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Caroline Village in Jacksonville, FL, where stylish living meets comfort. Choose from spacious studios, one, or two-bedroom apartments equipped with modern amenities. With on-site management, security patrols, and vibrant community events, you’ll find a welcoming atmosphere. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Caroline Village in Jacksonville, FL, your furry friends can feel right at home. With spacious layouts accommodating up to two dogs or two cats, let your pets romp through our vibrant community while you enjoy stylish living. Experience comfort and convenience—both you and your pets deserve it!",
  "property_referafriend_blurb": "At Caroline Village in Jacksonville, FL, great friendships flourish alongside stylish living. Choose from our thoughtfully designed floor plans—be it a cozy studio or a spacious two-bedroom. Share the love of community with someone special; refer a friend to Caroline Village today and enhance your neighborhood experience!",
  "property_residentaccess_blurb": "Welcome to Caroline Village in Jacksonville, FL, where comfortable living meets convenience. Choose from stylish one-bedroom, two-bedroom, or studio floor plans that suit your lifestyle. Access your resident portal effortlessly to manage rent payments, schedule maintenance, and more—all at your fingertips for a seamless living experience!",
  "property_reviews_blurb": "At Caroline Village in Jacksonville, FL, our residents rave about the exceptional service from our team, especially Corrine and Jasmine. With a perfect blend of quiet surroundings and top-notch security, we go the extra mile to ensure your happiness. “Thank you for going above and beyond,” one resident joyfully shared. Join our community today!",
  "property_created_at": "1769433697547",
  "property_scheduletour_blurb": "At Caroline Village in Jacksonville, FL, our thoughtfully designed floor plans—offering cozy studios, spacious one, and two-bedroom apartments—perfectly blend comfort and style. Schedule a tour today to experience the vibrant community atmosphere and see what our residents love most about their home! Your ideal living space awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Caroline Village in Jacksonville, FL! With an array of thoughtfully designed floor plans—studio, one-bedroom, and two-bedroom options—your perfect home awaits. Our team will connect with you soon to help you explore all that our vibrant community has to offer!",
  "property_virtualtours_blurb": "Welcome to Caroline Village in Jacksonville, FL, where comfort meets style! Choose from our thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Experience your future home firsthand—take a virtual tour today and envision the lifestyle waiting for you at Caroline Village!",
  "property_copyright": "2026 All Rights Reserved. Caroline Village",
  "property_seo_title_home": "Caroline Village |  Apartments in Jacksonville, FL",
  "property_seo_description_home": "Discover comfort at Caroline Village, Jacksonville, FL. Enjoy beautifully remodeled apartments with unbeatable amenities!",
  "property_seo_title_floorplans": "Floor Plans | Jacksonville, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Caroline Village in Jacksonville, FL! Choose from stylish studio, cozy one-bedroom, or spacious two-bedroom layouts. Browse now!",
  "property_seo_title_amenities": "Amenities | Jacksonville, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover Caroline Village in Jacksonville, FL! Enjoy modern apartments with onsite management, picnic areas, and 24/7 maintenance.",
  "property_seo_title_gallery": "Gallery | Apartments in Jacksonville, FL",
  "property_seo_description_gallery": "Discover Caroline Village in Jacksonville: a welcoming apartment community with modern amenities, social events, and pet-friendly spaces. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Caroline Village Apartments",
  "property_seo_description_virtualtours": "Experience Caroline Village in Jacksonville, FL! Take a virtual tour of our stylish studio, one, and two-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Caroline Village Apartments",
  "property_seo_description_interactivemap": "Discover your ideal retreat at Caroline Village, Jacksonville, FL! Explore our interactive map for spacious, pet-friendly apartments with great amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jacksonville, FL",
  "property_seo_description_neighborhood": "Uncover the charm of Jacksonville at Caroline Village. Experience vibrant local favorites and hidden gems right outside your door. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | Caroline Village",
  "property_seo_description_contact": "Connect with Caroline Village in Jacksonville, FL! Inquire about our one and two-bedroom apartments and studio options. Our leasing team is ready to assist!",
  "property_seo_title_faqs": "FAQs | Apartments in Jacksonville, FL",
  "property_seo_description_faqs": "Get answers to your queries at Caroline Village in Jacksonville! From amenities to floor plans, our FAQs page has all you need for your next home sweet home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jacksonville, FL",
  "property_seo_description_reviews": "At Caroline Village, Jacksonville, residents enjoy a vibrant community with great amenities, pet-friendly spaces, and responsive management!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jacksonville, FL",
  "property_seo_description_applynow": "Experience vibrant living at Caroline Village in Jacksonville, FL! Choose from unique layouts, enjoy top-notch amenities, and feel right at home. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Caroline Village",
  "property_seo_description_residentaccess": "Seamlessly manage your life at Caroline Village in Jacksonville, FL. Access your resident portal to pay rent, schedule maintenance, and more in just a click!",
  "property_seo_title_referafriend": "Refer A Friend | Caroline Village",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Caroline Village in Jacksonville, FL, and enjoy exclusive perks together in your vibrant new home!",
  "property_seo_title_scheduletour": "Schedule a Tour | Caroline Village",
  "property_seo_description_scheduletour": "Experience vibrant living at Caroline Village in Jacksonville, FL. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Caroline Village",
  "property_seo_description_privacy": "Your trust matters! Read Caroline Village's privacy policy to learn how we safeguard your information while you enjoy your Jacksonville, FL home.",
  "property_seo_title_accessibility": "Website Accessibility | Caroline Village",
  "property_seo_description_accessibility": "Caroline Village in Jacksonville, FL promotes digital inclusion and accessibility for all, fostering a welcoming community for everyone.",
  "property_seo_title_sitemap": "Sitemap | Caroline Village",
  "property_seo_description_sitemap": "Explore Caroline Village in Jacksonville, FL! Visit our sitemap for a complete layout of amenities and available apartments.",
  "property_seo_title_thankyou": "Thank You | Caroline Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Caroline Village! Your journey to vibrant living in Jacksonville starts here. Expect a prompt response from our team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786634916219",
  "amenities": [
    {
      "id": "ec_53b62bc20baa7f05cf385787",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3947378f3fd88ffec4d13b33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Close to Shopping, Dining, Bus Routes and Much More!",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_664a8d38b2d6bea8dbc5b982",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_852deceac7b81c01d83afb72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Security Cameras, Safety Patrol and Controlled Access to Community Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_599663917b8471709901352c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdcf7d45df8f112351db2846",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Credit Cards Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35921ed8ff8c89b9a036ebae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_252f2db1737b6b5c670262d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Pest Control Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f7c3764b739046f194d7de0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10e4744dad94ecf5667e80df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Community laundry facilities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_433df3cb265c57d5495e8719",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Open & Efficient Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f59ae047c5b44e69aa76941e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Pets Welcome",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff6807809e8d4ce6d04dd123",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c8e72639efcc0e4c138d806",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "One and Two Bedroom Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86d8e794847c0d1cbbaf1277",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bars",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_625894b204c059b296f690ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96bab7374d893d9b4d8d3881",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78afebf052b9c6c6b30d6cdb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "external_id": "false",
      "title": "Onsite Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_620391f8-2798-4cd6-8166-de8fd2afc889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-b867-7528-80e5-2804890ae7b7.webp",
      "image_media": {
        "alt_text": "Open-plan living room with teal sofas, large windows, and a kitchen counter.",
        "public_id": "019d02d5-b867-7528-80e5-2804890ae7b7",
        "storage_key": "property/6767906449167008/019d02d5-b867-7528-80e5-2804890ae7b7.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Bright apartment living area with teal seating, plants, and a marble-look counter.",
      "link": "",
      "alt_text": "Open-plan living room with teal sofas, large windows, and a kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/e02f4be0-0af2-4c26-8af2-f24978f4c1e3"
    },
    {
      "id": "custom_37df4bb0-d0dd-4abf-b6eb-38b1ff2be619",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-b810-73f9-8f82-515606f1c395.webp",
      "image_media": {
        "alt_text": "Empty bedroom with gray walls, wood-look flooring, ceiling fan, open closet door and bathroom doorway.",
        "public_id": "019d02d5-b810-73f9-8f82-515606f1c395",
        "storage_key": "property/6767906449167008/019d02d5-b810-73f9-8f82-515606f1c395.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright unfurnished apartment bedroom with modern finishes and access to a closet and nearby bathroom.",
      "link": "",
      "alt_text": "Empty bedroom with gray walls, wood-look flooring, ceiling fan, open closet door and bathroom doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/d69f9ba9-574b-4227-bf78-b68b24ad44fd"
    },
    {
      "id": "custom_3636aaf3-c50f-4529-87b1-9d10afdd8fba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-b8c0-71ac-8c41-6f71460946f3.webp",
      "image_media": {
        "alt_text": "Open living area with a breakfast-bar kitchen, stainless steel fridge, and white cabinetry.",
        "public_id": "019d02d5-b8c0-71ac-8c41-6f71460946f3",
        "storage_key": "property/6767906449167008/019d02d5-b8c0-71ac-8c41-6f71460946f3.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Bright, open-concept living space with a modern kitchen and breakfast bar in a neutral-toned apartment.",
      "link": "",
      "alt_text": "Open living area with a breakfast-bar kitchen, stainless steel fridge, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/d069298e-6948-4f22-8821-520889ee946d"
    },
    {
      "id": "custom_2c29ab0c-7f28-4351-8815-f5d8ba389d1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-b90b-70fa-bea5-3341fa606c88.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment community courtyard with palm trees, green lawn, and walkways.",
        "public_id": "019d02d5-b90b-70fa-bea5-3341fa606c88",
        "storage_key": "property/6767906449167008/019d02d5-b90b-70fa-bea5-3341fa606c88.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Sunny courtyard of a multi-family community with palm trees, a circular landscaped island, and white apartment buildings.",
      "link": "",
      "alt_text": "Exterior view of an apartment community courtyard with palm trees, green lawn, and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/6531393f-1f63-4b89-b945-9eeb5c7d0174"
    },
    {
      "id": "custom_8df44d45-4bfc-4b53-9432-6c3605ae9a5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-c2ec-7180-ad9b-f8a77976165f.webp",
      "image_media": {
        "alt_text": "Exterior view of Caroline Village Apartments entrance with teal decorative panels and sign.",
        "public_id": "019d02d5-c2ec-7180-ad9b-f8a77976165f",
        "storage_key": "property/6767906449167008/019d02d5-c2ec-7180-ad9b-f8a77976165f.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Exterior signage and building entrance for Caroline Village Apartments, featuring teal decorative screens and the address 2929 Justina Rd.",
      "link": "",
      "alt_text": "Exterior view of Caroline Village Apartments entrance with teal decorative panels and sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/353c15ed-a87c-48e7-adb2-1f982a852a84"
    },
    {
      "id": "custom_c072d198-4a7a-46d1-97e3-e3814957b1ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-c404-7208-80ee-75bf5805421d.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a kitchen breakfast bar, stainless fridge, and gray walls.",
        "public_id": "019d02d5-c404-7208-80ee-75bf5805421d",
        "storage_key": "property/6767906449167008/019d02d5-c404-7208-80ee-75bf5805421d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Open living area with a modern kitchenette and breakfast bar in a multifamily apartment.",
      "link": "",
      "alt_text": "Open-concept living area with a kitchen breakfast bar, stainless fridge, and gray walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/4216a2d9-aaca-49aa-89b6-aa4581e0aa5a"
    },
    {
      "id": "custom_7906416e-0ffe-428f-a2bd-04824320c96c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-c5e6-713f-8aa4-acbb922786a3.webp",
      "image_media": {
        "alt_text": "Kitchen area with a stainless steel fridge, white cabinets, and marble countertop island.",
        "public_id": "019d02d5-c5e6-713f-8aa4-acbb922786a3",
        "storage_key": "property/6767906449167008/019d02d5-c5e6-713f-8aa4-acbb922786a3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with stainless steel fridge, white cabinets, and a marble-counter island.",
      "link": "",
      "alt_text": "Kitchen area with a stainless steel fridge, white cabinets, and marble countertop island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/566adf87-fab5-43cb-b6bb-3d53faabfb01"
    },
    {
      "id": "custom_4157757b-b3db-4ec8-821c-bc8f0ff662ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-c794-702c-aeb8-3c3dff7a8b47.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with an external staircase and teal decorative columns.",
        "public_id": "019d02d5-c794-702c-aeb8-3c3dff7a8b47",
        "storage_key": "property/6767906449167008/019d02d5-c794-702c-aeb8-3c3dff7a8b47.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a multi-unit apartment community with teal perforated columns, exterior walkways, and a parking area.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with an external staircase and teal decorative columns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/f6b9498f-eb10-41af-ba64-3a56cba3609c"
    },
    {
      "id": "custom_b7c96c9c-8095-4dcb-9323-1e49a84f9403",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-d022-7775-b27c-0e71bf7808a7.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-building apartment community with trees and parking.",
        "public_id": "019d02d5-d022-7775-b27c-0e71bf7808a7",
        "storage_key": "property/6767906449167008/019d02d5-d022-7775-b27c-0e71bf7808a7.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Aerial view of a suburban apartment community with multiple buildings, green spaces, and parking.",
      "link": "",
      "alt_text": "Aerial view of a multi-building apartment community with trees and parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/e852f6bb-a307-48c0-96e6-68739c9d815b"
    },
    {
      "id": "custom_fae3d599-ad9d-4dca-bbf6-8447a532cc24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-d0f9-74aa-89ac-27defa402f68.webp",
      "image_media": {
        "alt_text": "Empty living room with beige walls, wood-look flooring, and sliding door with vertical blinds.",
        "public_id": "019d02d5-d0f9-74aa-89ac-27defa402f68",
        "storage_key": "property/6767906449167008/019d02d5-d0f9-74aa-89ac-27defa402f68.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Bright, unfurnished living area in a modern apartment with neutral walls, wood-look flooring, and a sliding door with vertical blinds.",
      "link": "",
      "alt_text": "Empty living room with beige walls, wood-look flooring, and sliding door with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/06729345-1f9e-4357-a9de-8922e3f06edd"
    },
    {
      "id": "custom_273cab9c-ded4-417a-99fe-7ea2e331f46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-d1dc-719c-8a56-844af8669fc9.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with teal lattice columns and external staircases.",
        "public_id": "019d02d5-d1dc-719c-8a56-844af8669fc9",
        "storage_key": "property/6767906449167008/019d02d5-d1dc-719c-8a56-844af8669fc9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a multi-family community with teal lattice columns, white siding, and a long exterior staircase.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with teal lattice columns and external staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/f047b1cc-e3f4-4350-8c36-c0f523883e2f"
    },
    {
      "id": "custom_19b786d7-df17-40b7-bbe5-7e4bda911307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-d31a-71d9-9c30-91e5fe9c8fbc.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with teal lattice columns, stairs, and a parking lot.",
        "public_id": "019d02d5-d31a-71d9-9c30-91e5fe9c8fbc",
        "storage_key": "property/6767906449167008/019d02d5-d31a-71d9-9c30-91e5fe9c8fbc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a vintage-style apartment building with teal decorative columns, outdoor walkways, and a small parking area.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with teal lattice columns, stairs, and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/286b9fdd-38d9-4f54-920d-41b12ddbbdd6"
    },
    {
      "id": "custom_02bd1638-d72c-4763-b03d-a214fec84ea7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-dc73-724a-8091-6f3d28b55c23.webp",
      "image_media": {
        "alt_text": "Row of gray front-loading washing machines in a communal laundry room.",
        "public_id": "019d02d5-dc73-724a-8091-6f3d28b55c23",
        "storage_key": "property/6767906449167008/019d02d5-dc73-724a-8091-6f3d28b55c23.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site communal laundry room with multiple front-loading washers and dryers for residents.",
      "link": "",
      "alt_text": "Row of gray front-loading washing machines in a communal laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/d41ad695-47da-4d74-b059-1c9f53386266"
    },
    {
      "id": "custom_a5e094b3-489c-414e-b931-15109831052f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-dcd8-74e0-ad36-4401ad6b9939.webp",
      "image_media": {
        "alt_text": "White bathroom with toilet, vanity sink, and bathtub/shower in an apartment.",
        "public_id": "019d02d5-dcd8-74e0-ad36-4401ad6b9939",
        "storage_key": "property/6767906449167008/019d02d5-dcd8-74e0-ad36-4401ad6b9939.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Clean, modern apartment bathroom with a white vanity, mirror, toilet, and tub/shower.",
      "link": "",
      "alt_text": "White bathroom with toilet, vanity sink, and bathtub/shower in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/9762f3eb-6541-4dab-a9d4-a23bd43ec786"
    },
    {
      "id": "custom_d1422095-aabf-40e3-8b9b-d250df7aaa06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-de2d-73e9-a255-b2e162791431.webp",
      "image_media": {
        "alt_text": "Courtyard of a multi-unit apartment complex with palm trees, sidewalks, and green lawn.",
        "public_id": "019d02d5-de2d-73e9-a255-b2e162791431",
        "storage_key": "property/6767906449167008/019d02d5-de2d-73e9-a255-b2e162791431.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "A serene apartment community courtyard with palm trees, well-kept lawn, and connecting walkways between two-story buildings.",
      "link": "",
      "alt_text": "Courtyard of a multi-unit apartment complex with palm trees, sidewalks, and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/dc196619-477a-49db-b1aa-6750af2b09c5"
    },
    {
      "id": "custom_968436fd-5b53-4d4e-8ad0-835bf43ae4bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-df39-7178-acaa-a3ab9d23e38c.webp",
      "image_media": {
        "alt_text": "Empty apartment room with window, gray walls, and a ceiling fan.",
        "public_id": "019d02d5-df39-7178-acaa-a3ab9d23e38c",
        "storage_key": "property/6767906449167008/019d02d5-df39-7178-acaa-a3ab9d23e38c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Vacant apartment room with gray walls, laminate flooring, a window, and a ceiling fan.",
      "link": "",
      "alt_text": "Empty apartment room with window, gray walls, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/03602f1a-0dc5-4a35-a7c6-5a193894af81"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8572e7f9-e183-4a91-8b94-29b4f85ca743",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "The Bearded Pig",
      "poi_type": "Restaurants",
      "poi_address": "1808 Kings Ave, Jacksonville, FL 32207, USA",
      "poi_short_description": "Casual restaurant offering traditional BBQ options & tap brews, plus a patio with TVs.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, pulled pork, and ribs, along with sides like mac and cheese, baked beans, and banana pudding. They highlight the generous portions, reasonable prices, and lively atmosphere with indoor and outdoor seating. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-922f-7008-8160-cbafe3116902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-922f-7008-8160-cbafe3116902",
        "storage_key": "property/6767906449167008/019d02d4-922f-7008-8160-cbafe3116902.webp",
        "width": 1066,
        "height": 749
      },
      "poi_business_url": "https://www.thebeardedpigbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7854807827091398398&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-bearded-pig",
      "poi_latitude": "30.3100218",
      "poi_longitude": "-81.6505777",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-619-2247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afd-7379-a673-b50982da7994",
        "storage_key": "property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYGwoAa35YgR_p69KBriAW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_580bfc06-bb1c-42af-8bb1-f6d831247d7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "River & Post",
      "poi_type": "Restaurants",
      "poi_address": "1000 Riverside Ave #100, Jacksonville, FL 32204, USA",
      "poi_short_description": "Seafood & steaks with a regional twist in a contemporary space with a rooftop bar & scenic views.",
      "poi_long_description": "People say this restaurant serves delicious shrimp and grits, crab cakes, and bread pudding. They also highlight the attentive staff, relaxing atmosphere, and beautiful river views from the rooftop bar.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-929c-720b-98bb-46b8f2e6e21f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-929c-720b-98bb-46b8f2e6e21f",
        "storage_key": "property/6767906449167008/019d02d4-929c-720b-98bb-46b8f2e6e21f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverandpostjax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4298841392578480907&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river--post",
      "poi_latitude": "30.3141243",
      "poi_longitude": "-81.6780187",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-575-2366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afd-7379-a673-b50982da7994",
        "storage_key": "property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6ecL3e35YgRC8tiZniNqDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a79945bf-81aa-46fc-8ed6-7aa603011bb0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "9070 Merrill Rd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh food, including steak, fried chicken, and a salad bar. They also highlight the attentive and friendly service, and the clean atmosphere.\n\nOther reviews mention the desserts can be stale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-922d-721a-9457-c68869f48a12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-922d-721a-9457-c68869f48a12",
        "storage_key": "property/6767906449167008/019d02d4-922d-721a-9457-c68869f48a12.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/location-detail/632/golden-corral-merrill-rd/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=632",
      "poi_directions_map_url": "https://maps.google.com/?cid=625465370097879570&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "30.3516765",
      "poi_longitude": "-81.55048289999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-328-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afd-7379-a673-b50982da7994",
        "storage_key": "property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzVahXyz5YgREgr-s3AZrgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_c7524472-e1f8-43f9-b517-a11178793b65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Bartaco",
      "poi_type": "Restaurants",
      "poi_address": "1534 Oak St Suite 101, Jacksonville, FL 32204, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this taco restaurant serves delicious tacos, including pork belly, sesame ribeye, and Baja fish, as well as fresh guacamole, esquites, and plantains. They also highlight the fresh, interesting cocktails, such as margaritas and Palomas, and the quick, friendly service.\n\nOther reviews mention the tacos can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-925b-777c-a4f3-69ed6aebc726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-925b-777c-a4f3-69ed6aebc726",
        "storage_key": "property/6767906449167008/019d02d4-925b-777c-a4f3-69ed6aebc726.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bartaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16534360318923832043&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bartaco",
      "poi_latitude": "30.3128333",
      "poi_longitude": "-81.680847",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-809-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afd-7379-a673-b50982da7994",
        "storage_key": "property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSxHjiG35YgR6_rEdRvZdeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8c0427f0-0a67-4db7-a118-a57acc409510",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Delicias Colombianas Jax",
      "poi_type": "Restaurants",
      "poi_address": "10771 Beach Blvd #107, Jacksonville, FL 32246, USA",
      "poi_short_description": "Laid-back eatery featuring a menu of Colombian standards such as steak and chicken prepared many ways.",
      "poi_long_description": "Diners say this Colombian restaurant serves delicious food with big portions at affordable prices. They also highlight the friendly and attentive service, and the lively salsa music.\n\nSome reviews mention the food can be inauthentic.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-9b4d-75ef-a0ac-694b3085b2be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-9b4d-75ef-a0ac-694b3085b2be",
        "storage_key": "property/6767906449167008/019d02d4-9b4d-75ef-a0ac-694b3085b2be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://deliciascolombianasjax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939440171410659387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delicias-colombianas-jax",
      "poi_latitude": "30.2874601",
      "poi_longitude": "-81.5375672",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-527-3905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afd-7379-a673-b50982da7994",
        "storage_key": "property/6767906449167008/019d02d4-4afd-7379-a673-b50982da7994.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK4Y8QT215YgROxg6ZqpqjEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_baf3b3b7-7582-459d-9119-3a9d83183222",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Lotte Plaza Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9355 Atlantic Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Asian market chain stocking groceries & produce, plus Japanese, Korean & Chinese prepared foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, seafood, and Asian and European brands. They also highlight the excellent selection of fresh fish, the beautiful bakery, and the delicious marinated meats.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-9b84-714d-b433-162b37abefca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-9b84-714d-b433-162b37abefca",
        "storage_key": "property/6767906449167008/019d02d4-9b84-714d-b433-162b37abefca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lotteplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3058739284816750737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lotte-plaza-market",
      "poi_latitude": "30.3196123",
      "poi_longitude": "-81.55626149999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-817-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afc-7583-bb8a-df6f14e88396",
        "storage_key": "property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdhIYAC15YgRkegIdCzTcio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2da7b685-2156-40d3-8ff2-131a97ed7817",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "RD International Market And Food Court",
      "poi_type": "Shopping & Retail",
      "poi_address": "7534 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Grocery store featuring an international array of products, plus a bakery and seafood market.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of international products, especially fresh vegetables, spices, and ready-to-eat meals. They highlight the good prices, the fun, family-friendly atmosphere, and the unique imported items. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-9b28-726f-bf3c-cbf93cdcb76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-9b28-726f-bf3c-cbf93cdcb76b",
        "storage_key": "property/6767906449167008/019d02d4-9b28-726f-bf3c-cbf93cdcb76b.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "http://www.rdinternationalmarketjax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14288681607695045651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rd-international-market-and-food-court",
      "poi_latitude": "30.2871073",
      "poi_longitude": "-81.58029259999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-666-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afc-7583-bb8a-df6f14e88396",
        "storage_key": "property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9QYJ4i15YgRExRSrzeYS8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_260903df-2395-41e3-8c19-34b84c433821",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9520 Regency Sq Blvd N, Jacksonville, FL 32225, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a large selection of materials. They also highlight the helpful and polite staff.\n\nOther reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-9b27-72d2-9de3-0091bdbd48fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-9b27-72d2-9de3-0091bdbd48fa",
        "storage_key": "property/6767906449167008/019d02d4-9b27-72d2-9de3-0091bdbd48fa.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Regency-Square/FL/Jacksonville/32225/272?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415166588232632333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "30.3278652",
      "poi_longitude": "-81.55076269999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-727-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5086-74fe-8263-2ade09741ac6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5086-74fe-8263-2ade09741ac6",
        "storage_key": "property/6767906449167008/019d02d4-5086-74fe-8263-2ade09741ac6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo8J9wI205YgRDYjzibn252Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d11a4929-ca06-444d-bf21-0d9f67b0bda6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Publix Super Market at Riverside",
      "poi_type": "Shopping & Retail",
      "poi_address": "2033 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide selection of products, including fresh bakery items, deli subs, and organic options. They highlight the convenient location, good deals, and the ability to check blood pressure and weight. They also like the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-a3db-7780-9312-fd05268d26b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-a3db-7780-9312-fd05268d26b6",
        "storage_key": "property/6767906449167008/019d02d4-a3db-7780-9312-fd05268d26b6.webp",
        "width": 1280,
        "height": 897
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=849&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=14930034718607230754&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-riverside",
      "poi_latitude": "30.3113104",
      "poi_longitude": "-81.6821322",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-381-8610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afc-7583-bb8a-df6f14e88396",
        "storage_key": "property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ19MR3i35YgRIkfVTnkjMs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d71f4212-aa9b-4856-9a2a-5a75fbafe1c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Apna Bazar",
      "poi_type": "Shopping & Retail",
      "poi_address": "11173 Beach Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this supermarket offers a wide selection of halal meats, Turkish pastries, and Indian food items. They also highlight the friendly and helpful staff, and the clean and well-stocked grocery section.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-a3da-77ce-abba-4c19c2314dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-a3da-77ce-abba-4c19c2314dc2",
        "storage_key": "property/6767906449167008/019d02d4-a3da-77ce-abba-4c19c2314dc2.webp",
        "width": 752,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6835032198175174062&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "apna-bazar",
      "poi_latitude": "30.2876323",
      "poi_longitude": "-81.5299185",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-996-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4afc-7583-bb8a-df6f14e88396",
        "storage_key": "property/6767906449167008/019d02d4-4afc-7583-bb8a-df6f14e88396.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJed4tYT215YgRrq2WGJLp2l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_12b4aa53-b9ec-45d8-8978-c8ba4868d777",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville University",
      "poi_type": "Education",
      "poi_address": "2800 University Blvd N, Jacksonville, FL 32211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-f4c3-72ac-b250-c276e24d4c2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f4c3-72ac-b250-c276e24d4c2d",
        "storage_key": "property/6767906449167008/019d02d3-f4c3-72ac-b250-c276e24d4c2d.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.ju.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4823538255824375235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-university",
      "poi_latitude": "30.3529114",
      "poi_longitude": "-81.606213",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-256-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZzEzWVSx5YgRw03rynym8EI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2624c31d-3647-4af8-b4bf-4df746444745",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Florida State College at Jacksonville – Downtown Campus",
      "poi_type": "Education",
      "poi_address": "101 W State St, Jacksonville, FL 32202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-a5f4-71a1-949d-3795b8174f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-a5f4-71a1-949d-3795b8174f00",
        "storage_key": "property/6767906449167008/019d02d4-a5f4-71a1-949d-3795b8174f00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fscj.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17181229441065064473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "florida-state-college-at-jacksonville--downtown-campus",
      "poi_latitude": "30.33528919999999",
      "poi_longitude": "-81.6601938",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-633-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaaldkTy35YgRGZgqhyX9b-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6e154d51-cecb-4a4b-95bb-2d3a6d07ebb0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville Public Library",
      "poi_type": "Education",
      "poi_address": "303 N Laura St, Jacksonville, FL 32202, USA",
      "poi_short_description": "Public library with a children's section, a Memories Lab, and computers, plus exhibits.",
      "poi_long_description": "People say this public library offers a wealth of resources, including books, media, special collections, and diverse programming, such as Story Time and a Memory Lab. They highlight the beautiful and spacious building, and the easy parking even with the downtown location. They also like the helpful, knowledgeable, and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-a79d-7617-946e-6233963c54a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-a79d-7617-946e-6233963c54a3",
        "storage_key": "property/6767906449167008/019d02d4-a79d-7617-946e-6233963c54a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.jaxpubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7083278098735964542&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-public-library",
      "poi_latitude": "30.3290141",
      "poi_longitude": "-81.6584251",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-255-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi_UcHFix5YgRfiF26ObbTGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_bd27ce0c-833d-489d-bbeb-5812de28438b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Edward Waters University",
      "poi_type": "Education",
      "poi_address": "1658 Kings Rd, Jacksonville, FL 32209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-acb9-7533-9951-b5cec962ddba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-acb9-7533-9951-b5cec962ddba",
        "storage_key": "property/6767906449167008/019d02d4-acb9-7533-9951-b5cec962ddba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ew.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5970551491977598579&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edward-waters-university",
      "poi_latitude": "30.3436839",
      "poi_longitude": "-81.6836991",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-470-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJawuxeVq35YgRc9aA2PKo21I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d442a6da-31ee-4fe5-85b0-380d995abdb9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "370 Zoo Pkwy, Jacksonville, FL 32218, USA",
      "poi_short_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including tigers, giraffes, and jaguars, and features beautiful gardens and lush landscaping. They highlight the well-maintained enclosures, the interactive experiences like feeding giraffes and touching stingrays, and the fun activities for kids, such as a train ride and splash pad. They also like the friendly and knowledgeable staff, and the clean and well-organized facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-111c-702c-b0e6-a7e75702e39b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-111c-702c-b0e6-a7e75702e39b",
        "storage_key": "property/6767906449167008/019d02d4-111c-702c-b0e6-a7e75702e39b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jacksonvillezoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14793728661843698434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-zoo-and-botanical-gardens",
      "poi_latitude": "30.4040262",
      "poi_longitude": "-81.6436476",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-757-4463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UOOwKux5YgRAmO1YNbhTc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_dfaccff0-4723-4fc0-9068-a3baaaf3b8ba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "EverBank Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 EverBank Stadium Dr, Jacksonville, FL 32202, USA",
      "poi_short_description": "Imposing indoor-stadium home of football's Jacksonville Jaguars, with tailgate cabanas.",
      "poi_long_description": "People say this stadium offers a variety of seating options with good views of the field, and features large video boards and fan zones. They highlight the spirited atmosphere on game days and the friendly staff. They also like the convenient location near downtown.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-af7e-7496-a8ea-309f94538cfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-af7e-7496-a8ea-309f94538cfc",
        "storage_key": "property/6767906449167008/019d02d4-af7e-7496-a8ea-309f94538cfc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://tiaabankfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17993900729312667066&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "everbank-stadium",
      "poi_latitude": "30.3239099",
      "poi_longitude": "-81.6373497",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-633-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-eb0c-750b-bf00-1aed44cab1d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-eb0c-750b-bf00-1aed44cab1d2",
        "storage_key": "property/6767906449167008/019d02d4-eb0c-750b-bf00-1aed44cab1d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj9Q15qdJ5IgRuuVSpmAtt_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e6b0a25f-89c6-4b09-ae88-71d5b08a23d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "VyStar Veterans Memorial Arena",
      "poi_type": "Entertainment",
      "poi_address": "300 A Philip Randolph Blvd, Jacksonville, FL 32202, USA",
      "poi_short_description": "Multipurpose event space & sports venue is the home stadium for the AFL Sharks & the ABA Giants.",
      "poi_long_description": "Visitors say this arena is clean and modern, with friendly staff and spacious concourses. They also highlight the convenient parking and easy access to the arena.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-b038-703e-a168-e2161cac91e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b038-703e-a168-e2161cac91e6",
        "storage_key": "property/6767906449167008/019d02d4-b038-703e-a168-e2161cac91e6.webp",
        "width": 1280,
        "height": 896
      },
      "poi_business_url": "https://www.vystarveteransarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7726745750397966580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vystar-veterans-memorial-arena",
      "poi_latitude": "30.3258872",
      "poi_longitude": "-81.6450447",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-630-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4mWo-G25YgR9Ng6alLqOms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0c8a2c4a-0b68-43b3-ad1c-fc1942a2648f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Cummer Museum of Art & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "829 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_long_description": "Visitors say this art museum offers a peaceful and relaxing experience with diverse galleries, expansive gardens overlooking the St. Johns River, and a cafe with delicious lunch options. They also highlight the friendly and knowledgeable staff, beautiful river views, and the majestic live oak tree in the gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-0021-75c9-ad28-688910f404e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0021-75c9-ad28-688910f404e6",
        "storage_key": "property/6767906449167008/019d02d4-0021-75c9-ad28-688910f404e6.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://www.cummermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1730978020932146253&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cummer-museum-of-art--gardens",
      "poi_latitude": "30.3151378",
      "poi_longitude": "-81.6769552",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-356-6857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-58b7-772e-8c45-47b767d67e38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-58b7-772e-8c45-47b767d67e38",
        "storage_key": "property/6767906449167008/019d02d4-58b7-772e-8c45-47b767d67e38.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbZAOHG35YgRTVSrw1arBRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a01f6e83-2e93-4565-a095-e9caa38b17af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "MOSH (Museum Of Science & History)",
      "poi_type": "Entertainment",
      "poi_address": "1025 Museum Cir, Jacksonville, FL 32207, USA",
      "poi_short_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_long_description": "People say this science museum offers immersive permanent and traveling exhibits, including a planetarium show. They also highlight the fun and educational experience for kids and adults, and the friendly and helpful staff.\n\nSome reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-0185-76bd-904b-d098d2f26a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0185-76bd-904b-d098d2f26a85",
        "storage_key": "property/6767906449167008/019d02d4-0185-76bd-904b-d098d2f26a85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://themosh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369837136756052471&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mosh-museum-of-science--history",
      "poi_latitude": "30.31886519999999",
      "poi_longitude": "-81.65976669999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-396-6674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-58b7-772e-8c45-47b767d67e38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-58b7-772e-8c45-47b767d67e38",
        "storage_key": "property/6767906449167008/019d02d4-58b7-772e-8c45-47b767d67e38.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1gEIRC35YgR95HTLNTrRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5701bd3b-2816-45e6-a7ac-63816ff821ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Winston Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "221 Riverside Ave, Jacksonville, FL 32202, USA",
      "poi_short_description": "Family-friendly gym center for all ages featuring an indoor track, fitness classes.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes and fitness opportunities, including a pool, gym, and indoor track. They highlight the clean and well-maintained facilities, and the welcoming and community-minded atmosphere. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-b74c-76ea-aea0-0e5a517e95b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b74c-76ea-aea0-0e5a517e95b1",
        "storage_key": "property/6767906449167008/019d02d4-b74c-76ea-aea0-0e5a517e95b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fcymca.org/locations/winston-family-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4395695779191393637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winston-family-ymca",
      "poi_latitude": "30.321198",
      "poi_longitude": "-81.6714145",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-355-1436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQFwpW235YgRZQ1jkwWmAD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3008589a-5a3a-440a-a1d4-ffe883bb0fa3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Crunch Fitness - Regency Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9400 Atlantic Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Chain gym at Regency Park Shopping Center offering cardio and strength-training equipment, plus group classes.",
      "poi_long_description": "People say this gym offers a variety of fun classes, including Zumba, and has well-maintained equipment. They highlight the welcoming and non-judgmental atmosphere, and the free amenities like the Hydro Massage. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-b4bf-75ea-96b0-e114b0a1577f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b4bf-75ea-96b0-e114b0a1577f",
        "storage_key": "property/6767906449167008/019d02d4-b4bf-75ea-96b0-e114b0a1577f.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://crunch.com/locations/regency-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9765840362978010024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---regency-park",
      "poi_latitude": "30.31830669999999",
      "poi_longitude": "-81.55227239999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-456-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0adOT1C15YgRqON5iBE8h4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfdb15eb-0293-42bb-b6ae-4fb4d6f524ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Planet fitness (Commerce Center)",
      "poi_type": "Health and Wellness",
      "poi_address": "651 Commerce Center Dr Unit 300, Jacksonville, FL 32225, USA",
      "poi_short_description": "Spacious fitness center offering free weights, machines and a cardio area, plus tanning, massage and hydro-massage machines.",
      "poi_long_description": "People say this gym offers a variety of machines, including hydromassage tables, stand-up beds, and wellness pods, and is suitable for beginners to intermediate levels of training. They highlight the clean and organized facilities, and the friendly and helpful staff. They also like the convenient location and 24/7 access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-b860-760e-8425-4401c7ba9ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b860-760e-8425-4401c7ba9ed6",
        "storage_key": "property/6767906449167008/019d02d4-b860-760e-8425-4401c7ba9ed6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/jacksonville-southside-commons-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3548787503077201584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness-commerce-center",
      "poi_latitude": "30.3344825",
      "poi_longitude": "-81.5499892",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-667-3470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4sFDDW15YgRsBZDiG7TPzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_efae7845-7a36-4214-8387-4dd3f261c7f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8595 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Chain fitness center offering a variety of cardio machines and equipment, plus 24/7 access.",
      "poi_long_description": "People say this gym offers a variety of machines with time and set displays, tanning beds, and hydromassage. They also highlight the clean facilities, spacious showers and restrooms, and friendly, helpful staff.\n\nSome reviews mention the water can be warm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-b860-760e-8425-4401c7ba9ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-b860-760e-8425-4401c7ba9ed6",
        "storage_key": "property/6767906449167008/019d02d4-b860-760e-8425-4401c7ba9ed6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/jacksonville-promenade-shopping-center-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13114534144875546461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.2885792",
      "poi_longitude": "-81.5658342",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-802-0565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQSPeKa15YgRXccJLFIvALY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3584683a-0377-48d6-8984-6609fa2a399a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "EveryPet",
      "poi_type": "Health and Wellness",
      "poi_address": "6817 Norwood Ave, Jacksonville, FL 32208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-bb80-774b-a115-16e01c880396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-bb80-774b-a115-16e01c880396",
        "storage_key": "property/6767906449167008/019d02d4-bb80-774b-a115-16e01c880396.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "http://www.everypet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10820141788457331680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "everypet",
      "poi_latitude": "30.3802822",
      "poi_longitude": "-81.67006390000002",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-425-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncgLDiu05YgR4OtbCKHdKJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7181d0a2-8b72-4d66-bbfa-353400e228c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "TNT Gymnastics and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2683 St Johns Bluff Rd S Suite 107, Jacksonville, FL 32246, USA",
      "poi_short_description": "Kid-friendly gymnastics center offering recreational lessons and camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-be6d-754d-abc8-d05552a7c0a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-be6d-754d-abc8-d05552a7c0a6",
        "storage_key": "property/6767906449167008/019d02d4-be6d-754d-abc8-d05552a7c0a6.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.tntgymfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11569429632710021089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tnt-gymnastics-and-fitness",
      "poi_latitude": "30.29779199999999",
      "poi_longitude": "-81.5253249",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-998-8681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcR0pIyi15YgR4Q-PF_TejqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfe49ddc-296d-47d8-b72a-7e4a9497fb3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3444 Southside Blvd STE 103, Jacksonville, FL 32216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-c43a-71ab-a6b9-090f57ecc544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-c43a-71ab-a6b9-090f57ecc544",
        "storage_key": "property/6767906449167008/019d02d4-c43a-71ab-a6b9-090f57ecc544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/jacksonville-fl/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646364179663651428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "30.2833064",
      "poi_longitude": "-81.559912",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-646-1287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdaDp6C15YgRZIIHGrp65PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_51dfdf25-3cb7-4a29-9e3f-65b075e897f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Iron House Gym Jacksonville",
      "poi_type": "Health and Wellness",
      "poi_address": "9244 Arlington Expy B, Jacksonville, FL 32225, USA",
      "poi_short_description": "Around-the-clock gym with child care and a wide selection of equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-c4df-708d-bae3-1d2f4a00b0c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-c4df-708d-bae3-1d2f4a00b0c3",
        "storage_key": "property/6767906449167008/019d02d4-c4df-708d-bae3-1d2f4a00b0c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ironhousejax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15412174550388109630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iron-house-gym-jacksonville",
      "poi_latitude": "30.320804",
      "poi_longitude": "-81.5567614",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-329-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXTlZYfi15YgRPvEyrBgL49U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8968c171-2796-4ef2-b1b6-16e54abf071d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Hawthorn Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "1011 Park St, Jacksonville, FL 32204, USA",
      "poi_short_description": "Relaxed salon with friendly staff that provides cuts, balayage and color, plus beer and bourbon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-c7a7-764d-a33a-f0e8938e4cc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-c7a7-764d-a33a-f0e8938e4cc9",
        "storage_key": "property/6767906449167008/019d02d4-c7a7-764d-a33a-f0e8938e4cc9.webp",
        "width": 1280,
        "height": 1245
      },
      "poi_business_url": "https://hawthornsalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11408186552929891597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hawthorn-salon",
      "poi_latitude": "30.31494709999999",
      "poi_longitude": "-81.6804813",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-619-3092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSv_AXq35YgRDTXGCjoFUp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_8baeec74-29eb-4d3a-83c9-cff93f5a3876",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "UF Health Jacksonville",
      "poi_type": "Health and Wellness",
      "poi_address": "655 8th St W, Jacksonville, FL 32209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-3a02-770c-a9fa-1b2b8c6b4820.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3a02-770c-a9fa-1b2b8c6b4820",
        "storage_key": "property/6767906449167008/019d02d4-3a02-770c-a9fa-1b2b8c6b4820.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://ufhealthjax.org/locations/uf-health-jacksonville?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=18323229800635225191&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uf-health-jacksonville",
      "poi_latitude": "30.3482365",
      "poi_longitude": "-81.66335629999999",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-244-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-58b9-7038-b3c7-b67397d08331.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-58b9-7038-b3c7-b67397d08331",
        "storage_key": "property/6767906449167008/019d02d4-58b9-7038-b3c7-b67397d08331.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3HhAzS35YgRZ9S2TGwwSf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7b63f828-a172-4346-9ec5-203b602773fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Baptist Medical Center Jacksonville",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Prudential Dr, Jacksonville, FL 32207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-3abc-77db-a6b5-edb2f2856aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3abc-77db-a6b5-edb2f2856aef",
        "storage_key": "property/6767906449167008/019d02d4-3abc-77db-a6b5-edb2f2856aef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baptistjax.com/locations/baptist-medical-center-jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=8263115339206629753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baptist-medical-center-jacksonville",
      "poi_latitude": "30.3157717",
      "poi_longitude": "-81.66357769999999",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-58b9-7038-b3c7-b67397d08331.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-58b9-7038-b3c7-b67397d08331",
        "storage_key": "property/6767906449167008/019d02d4-58b9-7038-b3c7-b67397d08331.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXVwHwy35YgReRl-A597rHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d9097c1a-f9f0-4a78-819c-a90837f96d1e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1445 Millcoe Rd, Jacksonville, FL 32225, USA",
      "poi_short_description": "This 120 acre arboretum provides rustic trails through the woods & labelled plant life.",
      "poi_long_description": "People say this botanical garden offers beautiful trails, lovely gardens, and a variety of plants and trees. They highlight the peaceful and relaxing atmosphere, and the budget-friendly admission price. They also like the helpful staff and the well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-cc21-708a-9e6a-75b40b632594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-cc21-708a-9e6a-75b40b632594",
        "storage_key": "property/6767906449167008/019d02d4-cc21-708a-9e6a-75b40b632594.webp",
        "width": 824,
        "height": 618
      },
      "poi_business_url": "http://www.jacksonvillearboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12750401125056939110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-arboretum--botanical-gardens",
      "poi_latitude": "30.3461357",
      "poi_longitude": "-81.5397758",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-318-4342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_k9TmCz5YgRZoTCykSG8rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_4567ecd6-a969-4db8-9b51-a0f640756d34",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Ed Austin Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11751 McCormick Rd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Popular park with baseball diamonds, soccer fields & a walking trail, plus 18 holes of disc golf.",
      "poi_long_description": "Visitors say this park offers a disc golf course with 25 holes, walking trails, a skate park, playgrounds, and sports fields for soccer, baseball, football, and basketball. They also highlight the dog park, which has separate areas for large and small dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-cc4f-74eb-a79b-5d9d992fb2ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-cc4f-74eb-a79b-5d9d992fb2ae",
        "storage_key": "property/6767906449167008/019d02d4-cc4f-74eb-a79b-5d9d992fb2ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/ed-austin-regional-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8392485081629429349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ed-austin-regional-park",
      "poi_latitude": "30.3646978",
      "poi_longitude": "-81.5071858",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5085-704c-9fad-3d15e07237f2",
        "storage_key": "property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRy8krrdM5IgRZY5JabcYeHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3692a10b-ea6e-4acc-8ebe-b3d88552e301",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Southbank Riverwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 Museum Cir, Jacksonville, FL 32207, USA",
      "poi_short_description": "1.25-mi. paved promenade along the St. Johns River with art, benches & city & sunset views.",
      "poi_long_description": "People say this park offers a beautiful river walk with stunning views of the city skyline and opportunities to watch dolphins. They highlight the clean and well-maintained trails, the refreshing fountain, and the safe and relaxing atmosphere. They also like the playground for kids and the availability of water taxis and river tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-cdd9-75c8-ad92-ba51a679d367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-cdd9-75c8-ad92-ba51a679d367",
        "storage_key": "property/6767906449167008/019d02d4-cdd9-75c8-ad92-ba51a679d367.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://downtownjacksonville.org/locations/l-100-southbank-riverwalk.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1354982475969717184&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southbank-riverwalk",
      "poi_latitude": "30.3201479",
      "poi_longitude": "-81.6564993",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5085-704c-9fad-3d15e07237f2",
        "storage_key": "property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRW-9SK35YgRwOMNBWLdzRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4577a6d0-f262-4205-a7b0-5b0038734701",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1620 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Designed by Olmsted, 6 acres of open space along the St. Johns river used for jogging & walking.",
      "poi_long_description": "People say this memorial park offers beautiful scenery, a lovely view, and a peaceful atmosphere. They highlight the well-maintained grounds, the great space for walking, and the opportunity to see dolphins. They also like the historical significance and the pet-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-d080-75b8-ab9d-51158ab6dc1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d080-75b8-ab9d-51158ab6dc1e",
        "storage_key": "property/6767906449167008/019d02d4-d080-75b8-ab9d-51158ab6dc1e.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://memparkjax.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=256005310588158749&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "30.3108716",
      "poi_longitude": "-81.6792002",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5085-704c-9fad-3d15e07237f2",
        "storage_key": "property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcaNkne35YgRHYM4PnmDjQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7f9974c6-1c0a-4ba4-8450-2839e5c8df4a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Tree Hill Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7152 Lone Star Rd, Jacksonville, FL 32211, USA",
      "poi_short_description": "Trails, gardens, wildlife & a natural history museum for children on a large nature reserve.",
      "poi_long_description": "People say this nature preserve offers walking trails, a butterfly garden, and opportunities to interact with animals like goats, turtles, and chickens. They highlight the peaceful and educational experience, especially for families with young children, and the well-maintained trails and exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-fcb3-73bb-bb5c-423cd2d542be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-fcb3-73bb-bb5c-423cd2d542be",
        "storage_key": "property/6767906449167008/019d02d3-fcb3-73bb-bb5c-423cd2d542be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.treehill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12888109492179589982&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tree-hill-nature-center",
      "poi_latitude": "30.3334246",
      "poi_longitude": "-81.58278620000002",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-724-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5085-704c-9fad-3d15e07237f2",
        "storage_key": "property/6767906449167008/019d02d4-5085-704c-9fad-3d15e07237f2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN89aORO05YgRXlu0i0zD27I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8933f4a1-47de-476e-9b5e-ccf9913825fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville Executive at Craig Airport (JAXEX)",
      "poi_type": "Transportation & Transit",
      "poi_address": "855-1 St Johns Bluff Rd N, Jacksonville, FL 32225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-d37a-764a-99cb-2a2214ffa2d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d37a-764a-99cb-2a2214ffa2d0",
        "storage_key": "property/6767906449167008/019d02d4-d37a-764a-99cb-2a2214ffa2d0.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.flyjaxex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3800067980122684252&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-executive-at-craig-airport-jaxex",
      "poi_latitude": "30.3360249",
      "poi_longitude": "-81.5176219",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-641-7666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5ed9-7258-86d8-8cddbed09c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5ed9-7258-86d8-8cddbed09c7d",
        "storage_key": "property/6767906449167008/019d02d4-5ed9-7258-86d8-8cddbed09c7d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJNf1W0ay05YgRXHuMvbGNvDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4aad6daa-007f-4021-9111-b2bd67619793",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "LaVilla Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 LaVilla Center Drive, Jacksonville, FL 32204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-d53f-77ce-be39-389c3ebe8224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d53f-77ce-be39-389c3ebe8224",
        "storage_key": "property/6767906449167008/019d02d4-d53f-77ce-be39-389c3ebe8224.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://jtafla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13517302735550004224&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lavilla-station",
      "poi_latitude": "30.3290436",
      "poi_longitude": "-81.6722131",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSthVGq35YgRALzfYTgbl7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_428055fd-f7bd-4b24-8887-32ec8e849b4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "James Weldon Johnson Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Hogan St, Jacksonville, FL 32202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-d5f8-700d-b9e8-f4ec20af59c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d5f8-700d-b9e8-f4ec20af59c5",
        "storage_key": "property/6767906449167008/019d02d4-d5f8-700d-b9e8-f4ec20af59c5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9410024325046909748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "james-weldon-johnson-park",
      "poi_latitude": "30.32943939999999",
      "poi_longitude": "-81.6598374",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaX1wBe35YgRNLs0ZkQfl4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_4eeae29e-ff04-484a-b64f-7b9adf41cdc3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Bay St, Jacksonville, FL 32202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-d74e-7408-9bc6-63f8d8575a2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-d74e-7408-9bc6-63f8d8575a2d",
        "storage_key": "property/6767906449167008/019d02d4-d74e-7408-9bc6-63f8d8575a2d.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10934633345312872931&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-station",
      "poi_latitude": "30.3270757",
      "poi_longitude": "-81.66235859999999",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYbc7Ba35YgR49mD6Befv5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_8ee34f92-b21e-4162-be8e-7216aeaf0203",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Sky Harbor Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "785 Amelia Earhart Dr, Jacksonville, FL 32225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-da89-77ee-b210-1b9623a11bee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-da89-77ee-b210-1b9623a11bee",
        "storage_key": "property/6767906449167008/019d02d4-da89-77ee-b210-1b9623a11bee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://skyharboraviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18117221485746896035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-harbor-aviation",
      "poi_latitude": "30.3352632",
      "poi_longitude": "-81.5164382",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-641-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5ed9-7258-86d8-8cddbed09c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5ed9-7258-86d8-8cddbed09c7d",
        "storage_key": "property/6767906449167008/019d02d4-5ed9-7258-86d8-8cddbed09c7d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfslkau05YgRo7wEv_NMbfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c51d50c1-e2c1-4503-8bf9-dd4c6b928ab4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "FIS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "347 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-dc48-7349-8216-750107e3c099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-dc48-7349-8216-750107e3c099",
        "storage_key": "property/6767906449167008/019d02d4-dc48-7349-8216-750107e3c099.webp",
        "width": 884,
        "height": 584
      },
      "poi_business_url": "https://www.fisglobal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5382664508797814060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fis",
      "poi_latitude": "30.3210514",
      "poi_longitude": "-81.6730915",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-438-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwoIH3K35YgRLAX_J9oQs0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_889053ec-06ab-4f7d-a872-50a712a7e426",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "VyStar Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "76 S Laura St, Jacksonville, FL 32202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4060-77f8-80d7-c5dfec6f5502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-4060-77f8-80d7-c5dfec6f5502",
        "storage_key": "property/6767906449167008/019d02d4-4060-77f8-80d7-c5dfec6f5502.webp",
        "width": 948,
        "height": 567
      },
      "poi_business_url": "http://vystarcu.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4675011397130740431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vystar-tower",
      "poi_latitude": "30.3261178",
      "poi_longitude": "-81.6599507",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-777-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNcYWDeO35YgRz2Lhrhj64EA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_879a7d29-beaf-488d-bfe8-11ea2bff88eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Jacksonville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "117 W Duval St, Jacksonville, FL 32202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-e0ee-7678-880d-91ee5500a40d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e0ee-7678-880d-91ee5500a40d",
        "storage_key": "property/6767906449167008/019d02d4-e0ee-7678-880d-91ee5500a40d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.coj.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9416520470897936139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-city-hall",
      "poi_latitude": "30.3297827",
      "poi_longitude": "-81.6591413",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5ee0-738a-a0d5-8789554345b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5ee0-738a-a0d5-8789554345b8",
        "storage_key": "property/6767906449167008/019d02d4-5ee0-738a-a0d5-8789554345b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQU50xm35YgRC8cQOHozroI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_8f65261d-f415-40ef-b6c1-b803ef873f12",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Swisher",
      "poi_type": "Major Employers & Offices",
      "poi_address": "459 E 16th St, Jacksonville, FL 32206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-dfd5-7638-a0cf-38746dfa6ba3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-dfd5-7638-a0cf-38746dfa6ba3",
        "storage_key": "property/6767906449167008/019d02d4-dfd5-7638-a0cf-38746dfa6ba3.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "http://www.swisher.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2127248131552712886&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "swisher",
      "poi_latitude": "30.354125",
      "poi_longitude": "-81.64657199999999",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-353-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaeAVWNWw5YgRthhQrueAhR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7970afe2-2ddb-4203-ab3c-0e504bbf4e96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Riverplace Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 Riverplace Blvd, Jacksonville, FL 32207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-e2cc-70f6-9a45-db27b0b9a6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-e2cc-70f6-9a45-db27b0b9a6c5",
        "storage_key": "property/6767906449167008/019d02d4-e2cc-70f6-9a45-db27b0b9a6c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://riverplacetower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2060860643054034678&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverplace-tower",
      "poi_latitude": "30.3194703",
      "poi_longitude": "-81.65658770000002",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4ad7-709c-8f91-4ec803f4a8da",
        "storage_key": "property/6767906449167008/019d02d4-4ad7-709c-8f91-4ec803f4a8da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2bUNAW35YgR9p7RANalmRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b65c71b6-055c-4624-bda6-39a1cc26dbf9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Fort Caroline Elementary School",
      "poi_type": "Education",
      "poi_address": "3925 Athore Dr, Jacksonville, FL 32277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.duvalschools.org/fce",
      "poi_directions_map_url": "https://maps.google.com/?cid=5844732580318981805&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fort-caroline-elementary-school",
      "poi_latitude": "30.370872",
      "poi_longitude": "-81.593504",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 904-745-4904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL3blr-ez5YgRra4QqVCpHFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c86f938d-9749-48ea-8419-0f051dd094f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Arlington Middle School",
      "poi_type": "Education",
      "poi_address": "8141 Lone Star Rd, Jacksonville, FL 32211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.duvalschools.org/arlingtonmiddle",
      "poi_directions_map_url": "https://maps.google.com/?cid=12155822649544454841&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arlington-middle-school",
      "poi_latitude": "30.3400166",
      "poi_longitude": "-81.5699255",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 904-720-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI6kMoXq05YgRubK-oksosqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fb1e9012-6a20-4f1c-b654-bcf295f6cb99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "custom",
      "poi_name": "Terry Parker Sr High School",
      "poi_type": "Education",
      "poi_address": "7301 Parker School Rd, Jacksonville, FL 32211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019f1e95-1cb4-72dc-a93c-c2c4ddde6a32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1e95-1cb4-72dc-a93c-c2c4ddde6a32",
        "storage_key": "property/6767906449167008/019f1e95-1cb4-72dc-a93c-c2c4ddde6a32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://dcps.duvalschools.org/tphs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6588710028042559869&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "terry-parker-sr-high-school",
      "poi_latitude": "30.3418769",
      "poi_longitude": "-81.5761638",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 904-720-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-5089-75cc-9189-3b13d9b067bf",
        "storage_key": "property/6767906449167008/019d02d4-5089-75cc-9189-3b13d9b067bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_929t3a05YgRfeGHrdzMb1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_218ccee5436652fd0f450af4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b764919b3c890580d904c1bb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_f562979d483063906f4e7388",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_fba969534542f4674c873c51",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6e289d8f031240ebc142dd64",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d7fac0a9459331c71ad13b6b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "rating": "5",
      "name": "Janice Rivera",
      "text": "I have an amazing experience with Corine she answered all my questions and change the apartment my brother had for a village when he was not happy with the first one he got she even worked with me trying to get all the papers and even waiting after business hours for my brother to try to get the keys. The location of the apartment is perfect and it’s quiet plus they have cameras and a security guard going around the apartments. The customer that she has it’s amazing and if you have any problems she is quick to try to fix it. Thank you for going above and beyond for my brother and I to be happy with the apartment he got.",
      "date": "2025-11-25",
      "title": "false"
    },
    {
      "id": "ec_c886726f180df99c379a99a9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "rating": "4",
      "name": "Tammy Manning",
      "text": "The management Great Jasmine and Corrine is Awesome 😎 and maintenance.",
      "date": "2025-12-19",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_82db895aa9a738ca7e50b11a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d5-ab91-76db-aa30-d6209781a6e7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living room area with a balcony entrance",
        "public_id": "019d02d5-ab91-76db-aa30-d6209781a6e7",
        "storage_key": "property/6767906449167008/019d02d5-ab91-76db-aa30-d6209781a6e7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA- 761SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wn2qU7GLGJQ"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c52b0-545f-715d-8881-c2690033203c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-caroline-village",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-in-jacksonville-fl",
      "search_query": "pet friendly apartments in Jacksonville FL",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Jacksonville, FL",
      "h2_subtitle": "Discover pet-friendly living at Caroline Village in Jacksonville, FL. Our community welcomes you and your furry friends with open arms.",
      "page_copy": "At Caroline Village, we understand that pets are family, which is why we offer pet-friendly apartments in Jacksonville, FL. Nestled in the Arlington Manor neighborhood, our community provides a welcoming environment for both you and your four-legged companions. Enjoy a stroll through nearby parks or relax at our picnic area, perfect for spending quality time with your pets and neighbors.\n\nOur spacious studio, one, and two-bedroom floor plans boast modern amenities such as air conditioning and fully equipped kitchens, making it a comfortable home for your entire family. Located conveniently in Jacksonville, you'll find pet-friendly resources nearby, from pet supply stores to veterinary services. Choose Caroline Village for a community that truly embraces pets and offers a vibrant lifestyle for all residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Jacksonville, FL",
      "seo_description": "Find pet-friendly apartments at Caroline Village, Jacksonville, FL. Spacious homes with modern amenities await you and your furry family.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-arlington-manor",
      "search_query": "apartments with air conditioning in Arlington Manor",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Arlington Manor",
      "h2_subtitle": "Stay cool at Caroline Village in Arlington Manor. Our apartments feature efficient air conditioning systems for your comfort.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Caroline Village, offering apartments with air conditioning in Arlington Manor. Our community ensures you stay cool during Florida's warmest months, thanks to modern air conditioning systems in each of our studio, one, and two-bedroom homes. This is just one of the many amenities that make life here both comfortable and enjoyable.\n\nLocated in the heart of Jacksonville's Arlington Manor, Caroline Village provides more than just relief from the heat. You'll find a variety of conveniences at your doorstep, including shopping centers and local parks. Our well-maintained units, combined with onsite maintenance and a welcoming picnic area, make Caroline Village a great choice for anyone seeking a vibrant community in Jacksonville. Come and see why our residents love calling us home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "A/C Apartments in Arlington Manor",
      "seo_description": "Stay cool at Caroline Village, Arlington Manor. Air-conditioned studio, one, and two-bedroom apartments designed for comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "jax-fl-apartments-with-controlled-access",
      "search_query": "Jacksonville FL apartments with controlled access",
      "category": "Amenity",
      "h1_title": "Jacksonville FL Apartments with Access Control",
      "h2_subtitle": "Enjoy peace of mind with controlled access at Caroline Village in Jacksonville, FL. Our secure apartments offer a safe and welcoming environment.",
      "page_copy": "Located in the vibrant community of Arlington Manor, Caroline Village offers Jacksonville, FL apartments with controlled access, providing an enhanced sense of security. Our spacious studio, one, and two-bedroom homes are designed to offer you both comfort and peace of mind. Alongside our controlled access feature, you'll find fully equipped kitchens and modern air conditioning systems to ensure your complete comfort.\n\nWithin our welcoming community, you can explore a host of amenities, including a scenic picnic area where you can relax and socialize with neighbors. Caroline Village is just minutes away from shopping and parks, making it an ideal location for those who appreciate both convenience and safety. Whether you're enjoying the nearby attractions or simply soaking in the serenity of our community, Caroline Village offers a secure, friendly environment to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jacksonville FL Apartments with Access Control",
      "seo_description": "Secure your home at Caroline Village, Jacksonville, FL. Our apartments offer controlled access in a vibrant community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-duval-county",
      "search_query": "apartments with dishwasher in Duval County",
      "category": "Amenity",
      "h1_title": "Duval County Apartments with Dishwasher",
      "h2_subtitle": "Discover the convenience of a dishwasher-equipped home at Caroline Village in Duval County. Enjoy modern living with easy access to amenities.",
      "page_copy": "Caroline Village in Duval County offers the ultimate convenience with apartments featuring dishwashers, ideal for making daily chores a breeze. Choose from our spacious studio, one, or two-bedroom apartments that boast modern amenities, including fully equipped kitchens, air conditioning, and onsite maintenance—all designed to enhance your living experience.\n\nSituated in the Arlington Manor neighborhood, Caroline Village combines comfort with convenience, providing a vibrant community atmosphere just steps from shopping and local parks. Enjoy the added benefit of a picnic area, perfect for gatherings and outdoor relaxation. With dishwasher-equipped homes, Caroline Village ensures you have more time to enjoy everything our welcoming community has to offer in Jacksonville, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Duval County Apartments with Dishwasher",
      "seo_description": "Find convenience at Caroline Village, Duval County. Apartments with dishwashers, modern amenities, and a vibrant community atmosphere await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "community-picnic-area-apartments-jax-32277",
      "search_query": "community picnic area apartments in Jacksonville 32277",
      "category": "Amenity",
      "h1_title": "Picnic Area Apartments in Jacksonville 32277",
      "h2_subtitle": "Enjoy a community picnic area at Caroline Village in Jacksonville 32277. A perfect place for relaxation and socializing with neighbors.",
      "page_copy": "Nestled in the heart of Jacksonville's 32277 area, Caroline Village offers community picnic area apartments that create a unique blend of comfort and communal living. Our spacious studio, one, and two-bedroom apartments are designed with you in mind, featuring modern amenities and conveniences like fully equipped kitchens and air conditioning.\n\nThe picnic area within our community is a highlight, offering residents a serene spot to gather, enjoy meals outdoors, or simply relax with friends and family. Located in the vibrant Arlington Manor neighborhood, Caroline Village provides easy access to shopping, parks, and a range of city attractions, all making it an ideal choice for those seeking both tranquility and convenience in Jacksonville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Community Picnic Area Apartments in Jacksonville",
      "seo_description": "Caroline Village offers Jacksonville 32277 apartments with a community picnic area, perfect for outdoor relaxation and gathering with neighbors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-arlington-manor-jax",
      "search_query": "one bedroom apartments arlington manor jacksonville",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Arlington Manor",
      "h2_subtitle": "Explore spacious one bedroom apartments at Caroline Village, located in the charming Arlington Manor neighborhood of Jacksonville.",
      "page_copy": "If you're searching for one bedroom apartments in Arlington Manor, Jacksonville, Caroline Village offers a perfect blend of comfort and convenience. Our thoughtfully designed one bedroom homes provide spacious, open layouts, ideal for singles or couples seeking a cozy retreat. Each unit boasts a fully equipped kitchen and modern air conditioning, ensuring a comfortable living experience.\n\nCaroline Village is situated in the welcoming Arlington Manor neighborhood, providing easy access to shopping, parks, and local attractions, while ensuring a serene residential atmosphere. With amenities such as a picnic area and onsite maintenance, residents can enjoy a hassle-free lifestyle with plenty of opportunities to engage with the vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Arlington Manor",
      "seo_description": "Discover one bedroom apartments at Caroline Village, Arlington Manor, Jacksonville. Enjoy modern living and community amenities in a desirable location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-duval-county",
      "search_query": "two bedroom apartments duval county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Duval County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Caroline Village, located in the heart of Duval County. Ideal for families and roommates alike.",
      "page_copy": "Caroline Village in Duval County offers exceptional two bedroom apartments that provide ample space and modern comfort for families or roommates. Our well-appointed residences feature open layouts and fully equipped kitchens, perfect for modern living. The on-site amenities, including air conditioning and a community picnic area, enhance your lifestyle, providing a blend of convenience and relaxation.\n\nSituated in the vibrant Arlington Manor neighborhood, Caroline Village ensures easy access to local shopping, parks, and major attractions in Jacksonville. With a focus on community and connectivity, our two bedroom apartments provide a welcoming environment paired with essential amenities like onsite maintenance and the acceptance of Section 8 applicants, catering to diverse living needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Duval County",
      "seo_description": "Explore spacious two bedroom apartments at Caroline Village, Duval County. Modern living with community amenities and easy access to Jacksonville attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "studio-apartments-near-justina-rd-jacksonville",
      "search_query": "studio apartments near justina rd jacksonville fl",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near Justina Rd, Jacksonville",
      "h2_subtitle": "Experience comfortable studio apartments just steps from Justina Rd in Jacksonville, FL. Ideal for modern, minimalist living.",
      "page_copy": "Located near Justina Rd, Caroline Village offers charming studio apartments in Jacksonville, FL, perfect for those seeking a minimalist lifestyle. Each studio is designed with an open layout and a fully equipped kitchen, making it easy to create a personalized home environment. With efficient air conditioning and a spacious design, you'll find comfort in every corner.\n\nWithin the dynamic Arlington Manor neighborhood of Duval County, Caroline Village places you within reach of local shops, parks, and community events. The on-site amenities, like our picnic area and community engagement opportunities, provide a friendly atmosphere where residents can relax and connect. With onsite maintenance and acceptance of Section 8 applicants, Caroline Village ensures convenience and accessibility for all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near Justina Rd, Jacksonville",
      "seo_description": "Discover studio apartments at Caroline Village near Justina Rd, Jacksonville, FL. Enjoy modern living with community amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-near-grasp-academy-jax",
      "search_query": "apartments near GRASP Academy Jacksonville",
      "category": "School",
      "h1_title": "Apartments Near GRASP Academy Jacksonville",
      "h2_subtitle": "Find convenient apartments near GRASP Academy, offering ideal living just minutes from educational excellence in Jacksonville.",
      "page_copy": "Situated just a short drive from GRASP Academy, Caroline Village provides an excellent choice for families and individuals seeking quality apartments near educational opportunities in Jacksonville. Our spacious studio, one, and two-bedroom homes offer modern amenities, including fully equipped kitchens and efficient air conditioning to meet diverse living needs.\n\nLiving in the vibrant Arlington Manor neighborhood of Duval County, you'll appreciate the quick access to GRASP Academy, ensuring a smooth daily commute. Experience community-focused living with amenities such as a picnic area and resident events that foster connectivity and engagement, along with the benefit of onsite maintenance and options for Section 8 applicants.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near GRASP Academy Jacksonville",
      "seo_description": "Live near GRASP Academy at Caroline Village, Jacksonville. Enjoy modern amenities and community living close to educational excellence.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "rentals-near-fort-caroline-elementary",
      "search_query": "rentals by Fort Caroline Elementary School FL",
      "category": "School",
      "h1_title": "Rentals by Fort Caroline Elementary School",
      "h2_subtitle": "Explore rentals conveniently located near Fort Caroline Elementary School in Jacksonville, FL, offering ideal living for families.",
      "page_copy": "Caroline Village provides exceptional rental options just minutes from Fort Caroline Elementary School, perfect for families seeking proximity to quality education in Jacksonville, FL. Our community features spacious living arrangements, including studio, one, and two-bedroom apartments, designed with fully equipped kitchens and open layouts to accommodate your needs.\n\nNestled in the welcoming Arlington Manor neighborhood of Duval County, Caroline Village allows for an easy commute while providing a range of amenities, such as a picnic area and regular resident activities. With vital services like onsite maintenance and options for Section 8 applicants, we ensure a supportive living environment right at the heart of Jacksonville's vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Fort Caroline Elementary School",
      "seo_description": "Find rentals near Fort Caroline Elementary School at Caroline Village, Jacksonville. Perfect for families seeking convenience and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-close-to-lake-lucina-elementary",
      "search_query": "close to Lake Lucina Elementary School apartments",
      "category": "School",
      "h1_title": "Close to Lake Lucina Elementary Apartments",
      "h2_subtitle": "Discover apartments conveniently close to Lake Lucina Elementary School, offering a prime location for families in Jacksonville.",
      "page_copy": "At Caroline Village, you'll find apartments perfectly situated close to Lake Lucina Elementary School in Jacksonville, ensuring easy access to exceptional educational opportunities. Our community offers a variety of living spaces, including spacious studio, one, and two-bedroom options, each with modern conveniences like fully equipped kitchens and air conditioning.\n\nLocated in the lively Arlington Manor neighborhood of Duval County, Caroline Village is ideal for families seeking a supportive community environment. Enjoy amenities such as a picnic area and engaging resident events, along with practical benefits like onsite maintenance and acceptance of Section 8 applicants. Experience a blend of comfort and convenience in a setting that caters to both your lifestyle and educational needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to Lake Lucina Elementary Apartments",
      "seo_description": "Find Caroline Village apartments close to Lake Lucina Elementary, Jacksonville for family-friendly, convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-near-merrill-road-elementary",
      "search_query": "Merrill Road Elementary School apartments Duval County",
      "category": "School",
      "h1_title": "Merrill Road Elementary School Apartments",
      "h2_subtitle": "Find apartments near Merrill Road Elementary School in Duval County, offering convenience and community for families.",
      "page_copy": "Located in the vibrant Arlington Manor neighborhood of Duval County, Caroline Village offers ideal apartment homes just a short distance from Merrill Road Elementary School. Perfect for families, our community features spacious studio, one, and two-bedroom apartments with modern amenities like fully equipped kitchens and refreshing air conditioning.\n\nEnjoy the perks of living in a community-focused environment, complete with a picnic area and regular resident events that encourage social interaction. Caroline Village also provides essential services such as onsite maintenance and accepts Section 8 applicants, making it a practical choice for families seeking the perfect blend of convenience and comfort in their next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Merrill Road Elementary School Apartments",
      "seo_description": "Live near Merrill Road Elementary in Caroline Village, Duval County. Enjoy modern amenities and community life close to local schools.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "rentals-near-arlington-middle-school-jacksonville",
      "search_query": "near Arlington Middle School Jacksonville rentals",
      "category": "School",
      "h1_title": "Rentals Near Arlington Middle School",
      "h2_subtitle": "Explore rentals near Arlington Middle School in Jacksonville, providing convenient living options for families in a vibrant community.",
      "page_copy": "Caroline Village offers fantastic rental options near Arlington Middle School in Jacksonville, making it a great choice for families prioritizing convenient schooling locations. Our community features spacious studio, one, and two-bedroom apartments with modern amenities, including fully equipped kitchens and advanced air conditioning systems.\n\nPositioned in the welcoming Arlington Manor area, residents enjoy a supportive community environment with amenities like a picnic area and regular resident events. Caroline Village accommodates various living needs, accepting Section 8 applicants and ensuring prompt responses with our onsite maintenance. Experience a harmonious blend of comfort and community right here in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Arlington Middle School",
      "seo_description": "Caroline Village offers rentals near Arlington Middle School, Jacksonville with ideal amenities and a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-around-terry-parker-sr-high",
      "search_query": "apartments around Terry Parker Sr High School",
      "category": "School",
      "h1_title": "Apartments Around Terry Parker Sr High",
      "h2_subtitle": "Find ideal apartments around Terry Parker Sr High School, offering comfortable living in Jacksonville's vibrant community.",
      "page_copy": "Nestled in Jacksonville's Arlington Manor neighborhood, Caroline Village offers exceptional apartment living around Terry Parker Sr High School. Our community boasts spacious studio, one, and two-bedroom apartments equipped with modern kitchens and air conditioning, perfect for families seeking quality living spaces.\n\nResidents at Caroline Village enjoy a lively atmosphere with amenities such as a picnic area and engaging resident events that foster community engagement. With onsite maintenance and acceptance of Section 8 applicants, Caroline Village provides practical living solutions in Duval County, ensuring families have everything they need for a convenient and comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around Terry Parker Sr High",
      "seo_description": "Discover Caroline Village apartments around Terry Parker Sr High School, Jacksonville, offering convenience and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "rentals-near-parsons-christian-academy",
      "search_query": "proximity to Parsons Christian Academy rentals",
      "category": "School",
      "h1_title": "Rentals Near Parsons Christian Academy",
      "h2_subtitle": "Discover rentals in proximity to Parsons Christian Academy, offering convenience and a vibrant community atmosphere in Jacksonville.",
      "page_copy": "Caroline Village provides excellent rental options in close proximity to Parsons Christian Academy, making it a prime location for those seeking ease of access to quality education in Jacksonville. Our apartments feature spacious studio, one, and two-bedroom layouts equipped with modern kitchens and air conditioning, ideal for families and individuals alike.\n\nLocated in the lively Arlington Manor neighborhood, Caroline Village ensures a sense of community with amenities like a picnic area and regular resident events. The property also supports diverse needs with onsite maintenance services and the acceptance of Section 8 applicants. Experience the blend of convenience and community life in Duval County at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Parsons Christian Academy",
      "seo_description": "Explore rentals near Parsons Christian Academy at Caroline Village, offering convenience and community-focused living in Jacksonville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-near-jacksonville-university",
      "search_query": "near Jacksonville University apartments",
      "category": "School",
      "h1_title": "Apartments Near Jacksonville University",
      "h2_subtitle": "Explore apartments near Jacksonville University, offering vibrant living options and modern amenities in a convenient location.",
      "page_copy": "Situated in the heart of Arlington Manor, Caroline Village offers prime living spaces near Jacksonville University, perfect for students and faculty seeking close proximity to campus. Choose from our spacious studio, one, or two-bedroom apartments, each featuring fully equipped kitchens and efficient air conditioning.\n\nOur community provides a host of amenities, including a picnic area and engaging resident events, fostering a sense of belonging and community. With onsite maintenance available and Section 8 applicants welcome, Caroline Village stands out as a versatile and accommodating housing option in Jacksonville's vibrant Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jacksonville University",
      "seo_description": "Discover Caroline Village apartments near Jacksonville University, featuring convenience and community amenities in Duval County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "rentals-near-merrill-road-elementary",
      "search_query": "Duval County rentals by Merrill Road Elementary School",
      "category": "School",
      "h1_title": "Duval County Rentals by Merrill Road Elementary",
      "h2_subtitle": "Find exceptional Duval County rentals near Merrill Road Elementary School, offering family-friendly living and modern conveniences.",
      "page_copy": "Caroline Village offers family-friendly rental options conveniently located by Merrill Road Elementary School in Duval County. Our spacious studio, one, and two-bedroom apartments come with modern kitchens and air conditioning, providing comfortable living for families prioritizing education.\n\nNestled in Arlington Manor, our community fosters a welcoming environment with amenities such as a picnic area and frequent resident events. We cater to various needs with onsite maintenance services and acceptance of Section 8 applicants, ensuring a practical living experience in Jacksonville. Discover the blend of convenience, community, and comfort at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Duval County Rentals by Merrill Road Elementary",
      "seo_description": "Explore Caroline Village rentals near Merrill Road Elementary in Duval County, offering easy access and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-st-vincents-southside",
      "search_query": "apartments near Ascension St. Vincent's Southside Hospital Jacksonville FL",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension St. Vincent's Southside",
      "h2_subtitle": "Discover modern apartments near Ascension St. Vincent's Southside Hospital, offering convenience and quality living in Jacksonville.",
      "page_copy": "Caroline Village offers convenient living options near Ascension St. Vincent's Southside Hospital, ideal for healthcare professionals and patients looking for nearby accommodations. Our thoughtfully designed studio, one, and two-bedroom apartments include fully equipped kitchens and air conditioning, ensuring a comfortable stay.\n\nLocated in the vibrant Arlington Manor neighborhood, Caroline Village provides a community atmosphere with a picnic area and engaging resident events. With onsite maintenance services and acceptance of Section 8 applicants, our rentals cater to various lifestyle needs. Experience comfort and convenience in Jacksonville's Duval County with Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension St. Vincent's Southside",
      "seo_description": "Find Caroline Village apartments near Ascension St. Vincent's Southside in Jacksonville, offering modern living with community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-close-to-baptist-medical-center-south",
      "search_query": "apartments close to Baptist Medical Center South Arlington Manor",
      "category": "Hospital",
      "h1_title": "Apartments Close to Baptist Medical Center South",
      "h2_subtitle": "Explore comfortable apartments close to Baptist Medical Center South in Arlington Manor, perfect for convenient living.",
      "page_copy": "At Caroline Village, our apartments provide an ideal living solution close to Baptist Medical Center South, suitable for healthcare workers and patients seeking nearby accommodations in Arlington Manor. Our spacious studio, one, and two-bedroom units come equipped with modern kitchens and air conditioning, setting the stage for a relaxing home environment.\n\nLocated in the vibrant community of Arlington Manor, Caroline Village offers amenities like a picnic area and community events, fostering a connected neighborhood vibe. With onsite maintenance and the acceptance of Section 8 applicants, our properties offer flexibility and reliability to cater to diverse needs. Live conveniently in Jacksonville's Duval County with Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Baptist Medical Center South",
      "seo_description": "Caroline Village in Arlington Manor offers apartments close to Baptist Medical Center South, providing comfort and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-near-cesery-park-jacksonville",
      "search_query": "apartments near Cesery Park Jacksonville",
      "category": "Park",
      "h1_title": "Apartments Near Cesery Park Jacksonville",
      "h2_subtitle": "Discover vibrant apartments near Cesery Park in Jacksonville, offering convenience and community activities just steps away.",
      "page_copy": "Caroline Village is located just a few steps away from Cesery Park in Jacksonville, providing an ideal spot for those who love outdoor activities and green spaces. Choose from our spacious studio, one, and two-bedroom apartments, complete with modern kitchens and air conditioning, perfect for comfortable living.\n\nSituated in the welcoming neighborhood of Arlington Manor, Caroline Village not only offers proximity to nature but also community features like a picnic area and various resident events. Our commitment to providing a well-rounded living experience is evident through onsite maintenance and the acceptance of Section 8 applicants, making our community diverse and accommodating. Experience the blend of nature, comfort, and community at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cesery Park Jacksonville",
      "seo_description": "Live near Cesery Park at Caroline Village, offering spacious apartments and community amenities close to nature in Jacksonville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "caroline-village-apartments-by-victory-park",
      "search_query": "Caroline Village apartments by Victory Park Arlington Manor",
      "category": "Park",
      "h1_title": "Caroline Village Apartments by Victory Park",
      "h2_subtitle": "Live near Victory Park at Caroline Village in Arlington Manor, offering modern living and community comfort.",
      "page_copy": "Nestled in the Arlington Manor neighborhood, Caroline Village apartments offer prime proximity to Victory Park. Our spacious studio, one, and two-bedroom units provide an ideal living option, featuring modern kitchens and efficient air conditioning for your comfort.\n\nAt Caroline Village, residents can enjoy a variety of amenities such as a picnic area and engaging community events, perfect for meeting neighbors and unwinding. We pride ourselves on catering to diverse needs with onsite maintenance services and the acceptance of Section 8 applicants. Experience the charm of living near Victory Park while enjoying modern comforts and a supportive community environment at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Caroline Village Apartments by Victory Park",
      "seo_description": "Explore Caroline Village apartments by Victory Park in Arlington Manor, offering spacious units and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "blue-cypress-park-close-by-apartments",
      "search_query": "Blue Cypress Park close by apartments",
      "category": "Park",
      "h1_title": "Apartments Near Blue Cypress Park",
      "h2_subtitle": "Discover community-focused apartments near Blue Cypress Park for convenience and relaxation amidst nature's beauty.",
      "page_copy": "Caroline Village in Arlington Manor offers an ideal location for those seeking apartments near Blue Cypress Park, where nature meets modern living. Our studio, one, and two-bedroom floor plans come complete with fully equipped kitchens and air conditioning, ensuring comfort and style.\n\nEnjoy being part of a vibrant community with amenities like a picnic area and resident events that bring people together. Caroline Village prioritizes convenience with onsite maintenance and welcoming options like accepting Section 8 applicants. Experience the perfect balance of nature and community by choosing Caroline Village as your home near Blue Cypress Park in Jacksonville's serene setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blue Cypress Park",
      "seo_description": "Live near Blue Cypress Park at Caroline Village. Enjoy comfort and community amenities in Arlington Manor, close to nature's retreats.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "tree-hill-nature-center-nearby-apartments-duval",
      "search_query": "Tree Hill Nature Center nearby apartments in Duval County",
      "category": "Park",
      "h1_title": "Apartments Near Tree Hill Nature Center",
      "h2_subtitle": "Explore apartments in Duval County near Tree Hill Nature Center, offering comfort and a natural retreat.",
      "page_copy": "Caroline Village presents the perfect living solution for those wanting to be close to Tree Hill Nature Center in Duval County. Our spacious studio, one, and two-bedroom apartments offer modern living with fully equipped kitchens and air conditioning.\n\nLocated in Jacksonville's Arlington Manor, residents enjoy community pleasures like a picnic area and regular events, fostering connection and leisure. Caroline Village supports diverse lifestyles with onsite maintenance and acceptance of Section 8 applicants, making it a welcoming home near nature. Experience the tranquility and community spirit at Caroline Village, your gateway to enjoying Tree Hill Nature Center and all its natural wonders.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tree Hill Nature Center",
      "seo_description": "Discover apartments near Tree Hill Nature Center at Caroline Village, offering modern living and community comfort in Duval County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "reddie-point-preserve-adjacent-apartments",
      "search_query": "Reddie Point Preserve adjacent apartments",
      "category": "Park",
      "h1_title": "Apartments Adjacent to Reddie Point Preserve",
      "h2_subtitle": "Discover contemporary living in apartments adjacent to Reddie Point Preserve, offering natural serenity and community charm.",
      "page_copy": "Caroline Village in Arlington Manor offers an excellent location for those seeking apartments adjacent to Reddie Point Preserve. Our modern studio, one, and two-bedroom apartments feature spacious layouts and fully equipped kitchens, complemented by efficient air conditioning.\n\nSurrounded by the vibrant community of Duval County, residents can enjoy amenities like a picnic area and fun-filled resident events. With onsite maintenance services and acceptance of Section 8 applicants, Caroline Village caters to diverse lifestyles. Enjoy the perfect combination of modern conveniences and natural beauty by choosing Caroline Village as your home near Reddie Point Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Adjacent to Reddie Point Preserve",
      "seo_description": "Find serenity in Caroline Village's apartments adjacent to Reddie Point Preserve, offering modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "arlington-lions-club-park-nearby-rentals",
      "search_query": "Arlington Lions Club Park nearby rentals",
      "category": "Park",
      "h1_title": "Rentals Near Arlington Lions Club Park",
      "h2_subtitle": "Discover delightful rentals nearby Arlington Lions Club Park, providing convenience with community charm in Jacksonville.",
      "page_copy": "Caroline Village, positioned conveniently in Arlington Manor, offers rentals near Arlington Lions Club Park for those seeking a community-focused lifestyle. Choose from our variety of spacious studio, one, and two-bedroom apartments that come equipped with modern kitchens and refreshing air conditioning.\n\nEmbrace an engaging living experience with amenities like our picnic area and regular resident events fostering community bonds. Plus, with features like onsite maintenance and acceptance of Section 8 applicants, Caroline Village brings comfort and inclusivity to all residents. Make your home at Caroline Village and enjoy proximity to Arlington Lions Club Park alongside vibrant community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Arlington Lions Club Park",
      "seo_description": "Find community and convenience at Caroline Village, offering rentals near Arlington Lions Club Park with modern amenities in Jacksonville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "apartments-close-to-castaway-island-preserve-32277",
      "search_query": "apartments close to Castaway Island Preserve 32277",
      "category": "Park",
      "h1_title": "Apartments Close to Castaway Island Preserve",
      "h2_subtitle": "Live near Castaway Island Preserve, with apartments offering natural beauty and modern amenities in the 32277 zip code.",
      "page_copy": "Located in the heart of Jacksonville's Arlington Manor, Caroline Village provides the perfect location for those searching for apartments close to Castaway Island Preserve. Our community features studio, one, and two-bedroom options, each designed with open layouts and fully equipped kitchens, ensuring comfort and style.\n\nEnjoy the blend of nature and modern living with amenities such as a picnic area and organized resident events that encourage community interaction. Caroline Village's onsite maintenance and acceptance of Section 8 applicants ensure a welcoming environment for all. Discover the ideal home base to explore the natural beauty of Castaway Island Preserve from your apartment at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Castaway Island Preserve",
      "seo_description": "Discover Caroline Village's inviting apartments close to Castaway Island Preserve, offering modern amenities and easy access to nature in the 32277 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167008",
      "source": "generator",
      "page_item_url": "rondette-park-vicinity-apartments-jacksonville",
      "search_query": "Rondette Park Park vicinity apartments Jacksonville",
      "category": "Park",
      "h1_title": "Apartments Near Rondette Park in Jacksonville",
      "h2_subtitle": "Explore Jacksonville living with apartments situated near Rondette Park, offering both serene surroundings and modern conveniences.",
      "page_copy": "Caroline Village, located in Jacksonville's Arlington Manor, offers an ideal spot for those seeking apartments near Rondette Park. Choose from our range of studio, one, and two-bedroom apartments, each boasting open layouts and fully equipped kitchens that cater to your lifestyle needs.\n\nEmbrace a vibrant community atmosphere with amenities like an inviting picnic area and engaging resident events. With onsite maintenance services and acceptance of Section 8 applicants, Caroline Village accommodates diverse living preferences. Enjoy the tranquility and recreational opportunities at Rondette Park, while relishing the conveniences of modern apartment living at Caroline Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
      "featured_image_media": {
        "alt_text": "Mailboxes located outside an apartment building entrance.",
        "public_id": "019d02d3-af44-7750-b980-23b2e6429bd4",
        "storage_key": "property/6767906449167008/019d02d3-af44-7750-b980-23b2e6429bd4.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rondette Park Jacksonville",
      "seo_description": "Caroline Village offers modern apartments near Rondette Park in Jacksonville, blending serene surroundings with community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5896"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11016335866"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M6XPQHNL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "345CVL"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('aJDSLlrtsrYtBSZopk')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "49194523396"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BK3285323"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImwycHZIY3dyNHBkZkhGa0pFZU1VdVE9PSIsInZhbHVlIjoiMjBzZUdyd3B6bldzUllEdU9mS2dTdz09IiwibWFjIjoiNzY0MzQzZjEwZTU0OWJlZWVhNWIzZGE2MTRmMjIzNmYwYTNkZGYwOWEyYjVjZmNkZjIwMjBjNjIwNTVkZDc5ZCJ9"
    }
  ],
  "custom_qb_id": "5896",
  "custom_repli_id": "11016335866",
  "custom_google_gtm_id": "GTM-M6XPQHNL",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "345CVL",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('aJDSLlrtsrYtBSZopk')</script>",
  "custom_hubspot_company_id": "49194523396",
  "custom_broker_license_number": "BK3285323",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImwycHZIY3dyNHBkZkhGa0pFZU1VdVE9PSIsInZhbHVlIjoiMjBzZUdyd3B6bldzUllEdU9mS2dTdz09IiwibWFjIjoiNzY0MzQzZjEwZTU0OWJlZWVhNWIzZGE2MTRmMjIzNmYwYTNkZGYwOWEyYjVjZmNkZjIwMjBjNjIwNTVkZDc5ZCJ9",
  "custom_audioeye_site_id": "bdf4e41f-93ad-44dd-8a12-f76a3bb96b41",
  "custom_audioeye_site_hash": "0c77d889c25ed35fc45132fe9c6bd696"
};

export const generatedAt = '2026-10-05T17:25:09.922Z';
